module.exports = __webpack_public_path__ + "img/bg_theme00011.e9fc36f7.jpg";